import React, { useState, useMemo } from "react";
import Carousel from "react-simply-carousel";
import Icon from "components/Elements/Icon/Icon";
import Image from "components/Elements/Image/Image.tsx";
import parse from "html-react-parser";

import "./CarouselContainer.scss";

const CarouselFormsEdit = ({
  setFormSelected,
  formList,
  viewType,
  pageLanguage,
}) => {
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [numSlice, setNumSlice] = useState(0);

  const numOfCarouselSections = () => {
    let numOfSections = formList.length - 2;
    return numOfSections;
  };

  useMemo(() => {
    if (formList) {
      let num = numOfCarouselSections();
      setNumSlice(num);
    }
  }, [formList]);

  return (
    <>
      {formList.length > 0 ? (
        <>
          <div className="carousel-container step-1-carousel">
            <Carousel
              className="carousel-content"
              updateOnItemClick
              centerMode
              infinite={formList.length > 3 ? false : false}
              containerProps={{
                style: {
                  maxWidth: formList.length > 3 ? "100%" : "100%",
                  justifyContent: "center",
                  direction: "ltr",
                },
              }}
              activeSlideIndex={activeSlideIndex}
              onRequestChange={setActiveSlideIndex}
              forwardBtnProps={{
                children: (
                  <div
                    className={`arrow arrow-right ${
                      activeSlideIndex === formList.length - 3 ? "last" : ""
                    }`}
                  >
                    <Icon iconClass="arrow-carousel" name="arrow-long-right" />
                  </div>
                ),
                style: {
                  width: 50,
                  height: 85,
                  alignSelf: "center",
                },
                show: formList.length > 3 ? true : false,
                "aria-label": "Next Slide",
              }}
              backwardBtnProps={{
                children: (
                  <div
                    className={`arrow arrow-left ${
                      activeSlideIndex === 0 ? "first" : ""
                    }`}
                  >
                    <Icon iconClass="arrow-carousel" name="arrow-long-left" />
                  </div>
                ),
                style: {
                  width: 50,
                  height: 85,
                  alignSelf: "center",
                },
                show: formList.length > 3 ? true : false,
                "aria-label": "Back Slide",
              }}
              itemsToShow={formList.length > 3 ? 3 : 0}
              speed={400}
            >
              {formList.map((item, i) => (
                <div
                  className="form-item"
                  key={i}
                  style={{
                    textAlign: "center",
                    boxSizing: "border-box",
                    direction:
                      pageLanguage === "he" || pageLanguage === "ar"
                        ? "rtl"
                        : "ltr",
                  }}
                >
                  <div
                    className={`item-container ${
                      i === 0 ? "click-form-carousel-tour" : ""
                    }`}
                    onClick={() => setFormSelected(item.EmbedPageFormId)}
                  >
                    <div className="form-image">
                      {item.EmbedPageFormImage && (
                        <Image src={item.EmbedPageFormImage} alt="" title="" />
                      )}
                    </div>
                    <div
                      className="form-content"
                      style={{
                        direction:
                          pageLanguage === "he" || pageLanguage === "ar"
                            ? "rtl"
                            : "ltr",
                      }}
                    >
                      <span className="title-form">
                        {parse(item.EmbedPageFormInnerTitle)}
                      </span>
                      {item.EmbedPageFormDescription && (
                        <span className="description-form">
                          {parse(item.EmbedPageFormDescription)}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
            <div className="dots-container">
              {formList.length > 3 &&
                formList.slice(0, numSlice).map((item, i) => (
                  <div
                    className={`dot ${activeSlideIndex === i ? "active" : ""}`}
                    key={i}
                  >
                    <i className="fas fa-circle"></i>
                  </div>
                ))}
            </div>
          </div>
          {/* Display carousel in tablet/mobile view (without arrows) */}
          <div className="carousel-mobile">
            <Carousel
              className="carousel-content"
              containerProps={{
                style: {
                  justifyContent: "space-between",
                  direction: "ltr",
                  paddingLeft: viewType === "mobile" ? "10px" : "50px",
                },
              }}
              activeSlideIndex={activeSlideIndex}
              onRequestChange={setActiveSlideIndex}
              speed={400}
              responsiveProps={[
                {
                  itemsToScroll: 1,
                },
              ]}
            >
              {formList.map((item, i) => (
                <div
                  className="form-item"
                  key={i}
                  style={{
                    textAlign: "center",
                    boxSizing: "border-box",
                    direction:
                      pageLanguage === "he" || pageLanguage === "ar"
                        ? "rtl"
                        : "ltr",
                  }}
                >
                  <div
                    className="item-container"
                    onClick={() => setFormSelected(item.EmbedPageFormId)}
                  >
                    <div className="form-image">
                      {item.EmbedPageFormImage && (
                        <Image src={item.EmbedPageFormImage} alt="" title="" />
                      )}
                    </div>
                    <div
                      className="form-content"
                      style={{
                        direction:
                          pageLanguage === "he" || pageLanguage === "ar"
                            ? "rtl"
                            : "ltr",
                      }}
                    >
                      <span className="title-form">
                        {parse(item.EmbedPageFormInnerTitle)}
                      </span>
                      {item.EmbedPageFormDescription && (
                        <span className="description-form">
                          {parse(item.EmbedPageFormDescription)}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
            <div className="dots-container">
              {formList.length > 0 &&
                formList.map((item, i) => (
                  <div
                    className={`dot ${activeSlideIndex === i ? "active" : ""}`}
                    key={i}
                  >
                    <i className="fas fa-circle"></i>
                  </div>
                ))}
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

export default CarouselFormsEdit;
